<template>
    <div class="flex items-center gap-x-4">
        <slot></slot>
    </div>
</template>
<script setup></script>
